module.exports = __webpack_public_path__ + "img/clock.5cb89eb9.svg";